export const industryType = [
  "E-commerce",
  "iGaming",
  "Travel and Hospitality",
  "Health and Wellness",
  "Finance and Banking",
  "Automotive",
  "Real Estate",
  "Education and Online Learning",
  "Entertainment and Media",
  "Food and Beverage Retail",
  "Technology and Software",
  "Nonprofits and Charities",
  "Beauty and Personal Care",
  "Home Services",
  "Sports and Fitness",
  "Fashion and Apparel",
  "Telecommunications",
  "Gaming",
  "Pharmaceuticals",
  "Consumer Electronics"
];